import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';
import type { CreateClusterBody } from 'api/computeClusters/types';

export const patchComputeClusterTE = <E = CF.API.ApiError>(
  { userId, computeClusterId, body }: { userId: string; computeClusterId: string; body: CreateClusterBody },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CreateClusterBody> =>
  fetchTE<CreateClusterBody, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters/${computeClusterId}`,
      method: 'PATCH',
      body,
    },
    onRejected,
  );
